 
export class Spoergsmaal {
        public opgaveId: string;
        public navn: string;
        public email: string;
        public telefonNummer: string;
        public skoleNavn: string;
        public funktion: string;
        public emne: string;
        public tekst: string;
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/Spoergsmaal.ts